module.exports = __webpack_public_path__ + "img/56.b8407b25.jpg";